import BaseModel from './BaseModel';

import { Brick } from './Bricks';

/** Class representing a workflow. */
class Workflow extends BaseModel {
    static STATUS_PENDING = 'pending';
    static STATUS_RUNNING = 'running';
    static STATUS_SUCCESS = 'success';
    static STATUS_FAILED  = 'failed';

    constructor(properties) {
        super(properties);

        if (this.bricks)
            this.bricks = (this.bricks || []).map(props => Brick.make(props));

        if (this.next)
            this.next = (this.next || []).map(props => Brick.make(props));
    }

    /**
     * Get the current brick
     *
     * @return {Brick}
     */
    getCurrentBrick() {
        const index = this.context?.__current__ || 0;
        return this.bricks[index] ?? null;
    }

    /**
     * Get the current brick index
     *
     * @return {Brick}
     */
    getCurrentBrickIndex() {
        return this.context?.__current__ || 0;
    }

    /**
     * Get the messages
     *
     * @return {String[]}
     */
    getMessages() {
        return this.context?.__messages__;
    }

    /**
     * Get the error messages
     *
     * @return {String[]}
     */
    getErrors() {
        return this.context?.__errors__;
    }

    /**
     * Check if this workflow is pending
     *
     * @return {Boolean}
     */
    isPending() {
        return this.context.__status__ === Workflow.STATUS_PENDING;
    }

    /**
     * Check if this workflow is running
     *
     * @return {Boolean}
     */
    isRunning() {
        return this.context.__status__ === Workflow.STATUS_RUNNING;
    }

    /**
     * Check if this workflow has succeeded
     *
     * @return {Boolean}
     */
    succeeded() {
        return this.context.__status__ === Workflow.STATUS_SUCCESS;
    }

    /**
     * Check if this workflow has failed
     *
     * @return {Boolean}
     */
    failed() {
        return this.context.__status__ === Workflow.STATUS_FAILED;
    }

}

export default Workflow;
